export default __webpack_public_path__ + "static/media/setting.1d3ed39b.svg";